import { useQuery, useSuspenseQuery } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { feedbackAndQuestionNoticeDetailsSchema } from '../../../common/validations/feedbackAndQuestionNotice'

import { get } from 'api/apiClient'
import { createBlobUrl } from 'views/DefectNotice/utils'

const params = (contractUuid: string, uuid: string) => ({
  queryKey: [`${API_ENDPOINTS.CONTRACTS}/${contractUuid}/questions/${uuid}`],
  queryFn: async () => {
    const questionNotice = await get(
      `${API_ENDPOINTS.CONTRACTS}/${contractUuid}/questions/${uuid}`,
      feedbackAndQuestionNoticeDetailsSchema
    )
    const files = await Promise.all(
      (questionNotice.files ?? []).map(async (file) => ({
        ...file,
        url: await createBlobUrl(file.url),
      }))
    )

    return {
      ...questionNotice,
      files,
    }
  },
})

export const useAPIGetQuestionNotice = (contractUuid: string, uuid: string) =>
  useQuery(params(contractUuid, uuid))

export const useAPIGetQuestionNoticeSuspense = (
  contractUuid: string,
  uuid: string
) => useSuspenseQuery(params(contractUuid, uuid))
